<template>
	<div>
		<div class="reserve_page_header">
			<v-layout align-center>
				<div class="white--text reserve_page_mainText">
					{{ reservedayData.business.title }}
					<div class="sub">{{ reservedayData.title }} {{ reserveGroup.title }}</div>
				</div>
				<v-spacer></v-spacer>
				<div>
					<v-btn icon @click="logout()" class="ml-1" dark>
						<v-icon size="24">mdi-logout</v-icon>
					</v-btn>
				</div>
			</v-layout>
			<v-layout align-center class="mt-2">
				<div class="white--text" style="font-size: 12px;">
					{{ $moment().format('YYYY.MM.DD (dd)') }}
				</div>
				<v-spacer></v-spacer>
				<div class="reserve_page_info mr-1">등록 {{ count2 + count3 }}</div>
				<div class="reserve_page_info mr-1">반영 {{ count2 }}</div>
				<div class="reserve_page_info">
					미반영 <span class="mr-1">{{ count3 }}</span>
				</div>
			</v-layout>
		</div>
		<div class="reserve_page_newCustomer">
			<v-layout align-center class="mb-4">
				<div class="reserve_page_title">
					신규 등록 고객
				</div>
				<v-spacer></v-spacer>
				<v-btn
					x-small
					color="MainColor1"
					@click="
						() => {
							if (refreshCount === 0) refresh()
						}
					"
					dark
					>{{ refreshCount > 0 ? refreshCount : '새로고침' }}</v-btn
				>
			</v-layout>
			<v-layout wrap class="main_layout">
				<v-flex xs12 v-for="(list, i) in newCustomer" :key="i" style="overflow: auto; min-width: 270px;" class="mb-2">
					<v-layout align-center class="reserve_page_newCustomer_List">
						<div class="info1">고객명</div>
						<div class="info2">{{ list.name }}</div>
						<div class="info1">
							연락처
						</div>
						<div class="info2">{{ list.phone }}</div>
						<v-btn small dense height="23" color="primary" @click="detailCustomer(list)" dark>반영</v-btn>
					</v-layout>
				</v-flex>
			</v-layout>
		</div>

		<div class="reserve_page_newCustomer">
			<v-layout align-center>
				<v-flex mr-2 class="search_select" style="width:112px !important; max-width:112px !important;">
					<selectBox :sel="searchsel3" class="searchSel"></selectBox>
				</v-flex>
				<v-flex>
					<v-text-field
						class="pt-0 mt-0"
						hide-details
						v-model="nameAndPhone"
						placeholder="이름/휴대폰번호 검색하세요."
						append-icon="mdi-magnify"
						@keyup.enter="reserveusers()"
					></v-text-field>
				</v-flex>
			</v-layout>
			<v-layout align-center class="mt-2 mb-4">
				<div>
					<DatepickerDialog :picker="startPicker" @input="realRangeTimeCount"> </DatepickerDialog>
				</div>
				<span class="mx-1"> ~ </span>
				<div>
					<DatepickerDialog :picker="endPicker" @input="realRangeTimeCount" :allowed_dates="allowed_datesEnd2"></DatepickerDialog>
				</div>
			</v-layout>
			<v-layout align-center>
				<div class="result-search">
					검색결과 <span class="count">{{ reserveCount }}</span
					>건
				</div>
				<v-spacer></v-spacer>
				<v-flex mr-2 class="search_select" style="width:82px !important; max-width:82px !important;">
					<selectBox :sel="searchsel" @change="realRangeTimeCount" class="searchSel"></selectBox>
				</v-flex>
				<v-flex class="search_select" style="width:120px !important; max-width:120px !important;">
					<selectBox :sel="searchsel2" @change="realRangeTimeCount" class="searchSel"></selectBox>
				</v-flex>
			</v-layout>
			<datatable
				:datatable="datatable"
				class="tbl-type01 reserve_page_datatable"
				excelUseYn="false"
				excelTextYn="false"
				@click="detailCustomer"
			>
			</datatable>
			<v-pagination class="mt-2" :key="pageKey" v-model="page" :length="pageCount" @input="reserveusers" color="#006986"></v-pagination>
			<v-dialog v-model="detailCustomerDialog" content-class="detail-customer-dialog">
				<v-layout align-center class="reserve_page_header">
					<div class="white--text reserve_page_mainText">
						고객반영하기
					</div>
					<v-spacer></v-spacer>
					<div>
						<v-btn icon @click="detailCustomerDialog = !detailCustomerDialog" class="ml-1" dark>
							<v-icon size="24">mdi-close</v-icon>
						</v-btn>
					</div>
				</v-layout>
				<div class="pa-3">
					<div class="reserve_page_title mb-2">
						고객정보
					</div>
					<v-layout align-center class="reserve_page_info_dialog">
						<div class="info-title" style="width: 75px; border-top: 1px solid #323153 !important;">
							이름
						</div>
						<div class="info-value" style="border-top: 1px solid #323153 !important;">
							{{ dialogItem.name }}
						</div>
						<div class="info-title px-1" style="width: 75px; border-top: 1px solid #323153 !important;">
							휴대전화
						</div>
						<div class="info-value" style="border-top: 1px solid #323153 !important;">
							{{ dialogItem.phone }}
						</div>
					</v-layout>
					<v-layout align-center class="reserve_page_info_dialog">
						<div class="info-title" style="width: 75px;">
							참여캠페인
						</div>
						<div class="info-value text-left pl-1">
							{{ dialogItem.title }}
						</div>
					</v-layout>
					<v-layout align-center class="reserve_page_info_dialog">
						<div class="info-title" style="width: 75px;">
							등록일시
						</div>
						<div class="info-value text-left pl-1">
							{{ $moment(dialogItem.created_at).format('YYYY-MM-DD HH:mm') }}
						</div>
					</v-layout>
					<div class="reserve_page_title mt-4 mb-2" v-show="dialogItem.userData.length > 0">
						답변내용
					</div>
					<v-layout align-center class="reserve_page_info_dialog" v-for="(list, i) in dialogItem.userData" :key="i">
						<div class="info-title" :style="i === 0 ? 'border-top: 1px solid #323153 !important; width: 75px;' : 'width: 75px;'">
							{{ list.codename }}
						</div>
						<div class="info-value text-left pl-1" :style="i === 0 ? 'border-top: 1px solid #323153 !important;' : ''">
							{{ list.value }}
						</div>
					</v-layout>
					<div class="reserve_page_title mt-4 mb-2">
						반영등급
					</div>
					<v-radio-group v-model="custlike" row hide-details>
						<v-radio color="MainColor1" v-for="n in likeList" :key="n" :label="`${n}`" :value="n"></v-radio>
					</v-radio-group>
				</div>
				<v-layout class="mt-4">
					<v-btn class="bottom-btn" height="47" color="#9FA6A9" dark elevation="0" @click="detailCustomerDialog = !detailCustomerDialog"
						>닫기</v-btn
					>
					<v-btn class="bottom-btn" height="47" color="#006986" dark elevation="0" @click="updateReserveuser">반영하기</v-btn>
				</v-layout>
			</v-dialog>
		</div>
		<sweetAlert :dialog="sweetInfo" />
	</div>
</template>
<script>
import { datatable, DatepickerDialog, selectBox, sweetAlert } from '@/components'
export default {
	components: {
		sweetAlert,
		datatable,
		DatepickerDialog,
		selectBox,
	},
	data() {
		return {
			pageKey: 0,
			reserveCount: 0,
			refreshCount: 0,
			dialogItem: {
				name: '',
				phone: '',
				id: null,
				userData: [],
			},
			custlike: 'C',
			likeList: ['S', 'A', 'B', 'C', 'D'],
			answers: [],
			detailCustomerDialog: false,
			sweetInfo: {
				open: false,
				title: '고객반영하기',
				content: `고객 정보를 저장합니다.`,
				modalIcon: 'success',
				cancelBtnText: '확인',
				buttonType: 'oneBtn',
			},
			searchsel: {
				value: '전체',
				errorMessage: '',
				hideDetail: true,
				items: ['전체', 'S', 'A', 'B', 'C', 'D', '-'],
				outlined: true,
			},
			// 기간별
			searchsel2: {
				value: '10개 보기',
				errorMessage: '',
				hideDetail: true,
				items: ['10개 보기', '30개 보기', '50개 보기'],
				outlined: true,
			},
			searchsel3: {
				value: '이름',
				errorMessage: '',
				hideDetail: true,
				items: ['이름', '휴대전화'],
				outlined: true,
			},
			startPicker: {
				date: this.$moment()
					.subtract(30, 'days')
					.format('YYYY-MM-DD'),
				class: 'whiteBack defalut-date-picker-setting',
			},
			endPicker: { date: this.$moment().format('YYYY-MM-DD'), class: 'whiteBack defalut-date-picker-setting' },
			nameAndPhone: '',
			datatable: {
				headers: [
					{ text: '이름', value: 'name', align: 'center', sortable: false, width: '48px' },
					{ text: '연락처', value: 'phone', align: 'center', sortable: false, width: '82px' },
					{ text: '등록일', value: 'created_at_time', align: 'center', width: '78px', sortable: false },
					{ text: '상태', value: 'reserve_page_status', align: 'center', sortable: false },
					{
						text: '비고',
						align: 'center',
						value: 'custlike',
						sortable: false,
					},
				],
				items: [],
				hidedefaultfooter: true,
				noweditting: '',
				itemPerPage: 999999,
				// title: x.name,
				onlyAgree: false,
				// inputboxId: x.id,
			},
			page: 1,
			pageCount: 0,
			newCustomer: [],
			item: {},
			count1: 0,
			count2: 0,
			count3: 0,
			reservedayData: {
				title: '',
				business: { title: '' },
			},
			reserveGroup: { title: '' },
		}
	},
	created() {
		this.reserveLoginCheck()
		this.reserveday()
		this.reserveusers()
		this.new_reserveusers()
		this.reserveusers_count(true)
		this.reserveusers_count(false)
		this.$moment.locale('ko')
	},
	computed: {
		ItemPerpage() {
			if (this.searchsel2.value === this.searchsel2.items[0]) return 10
			else if (this.searchsel2.value === this.searchsel2.items[1]) return 30
			else if (this.searchsel2.value === this.searchsel2.items[2]) return 50
			else return 10
		},
	},
	methods: {
		reserveLoginCheck() {
			if (!localStorage.getItem('reserver')) {
				alert('권한이 없는 사용자 입니다. 다시 로그인해 주세요.')
				return this.$router
					.push({ name: 'reserve_login', params: { code: this.$route.params.code, qrcode: this.$route.params.qrcode } })
					.catch(() => {})
			}
			const data = {
				created_at: localStorage.getItem('reserver').split(',')[1],
				updated_at: localStorage.getItem('reserver').split(',')[1],
				secret: localStorage.getItem('reserver').split(',')[0],
			}
			this.$store
				.dispatch('reserveLoginCheck', data)
				.then(() => {})
				.catch(() => {
					alert('권한이 없는 사용자 입니다. 다시 로그인해 주세요.')
					this.$router
						.push({ name: 'reserve_login', params: { code: this.$route.params.code, qrcode: this.$route.params.qrcode } })
						.catch(() => {})
				})
		},
		reserveday() {
			const data = {
				code: this.$route.params.code,
			}
			this.$store.dispatch('reservedays', data).then(res => {
				if (res.data.reservedays.length === 0) {
					alert('존재하지 않는 프로젝트 입니다.')
					return this.$router.push({ name: 'reserve_login', params: { code: this.$route.params.code, qrcode: this.$route.params.qrcode } })
				} else this.reservedayData = res.data.reservedays[0]
				this.$store.dispatch('reservedayGroups', { qrcode: this.$route.params.qrcode }).then(res => {
					if (res.data.reservedayGroups.length === 0) {
						alert('존재하지 않는 거점 입니다.')
						return this.$router.push({
							name: 'reserve_login',
							params: { code: this.$route.params.code, qrcode: this.$route.params.qrcode },
						})
					} else this.reserveGroup = res.data.reservedayGroups[0]
				})
			})
		},
		reserveusers_count(custlikeApply) {
			const data = {
				code: this.$route.params.code,
				reserveGroupCode: this.$route.params.qrcode,
			}
			if (custlikeApply) data.custlikeApply = custlikeApply
			else data.custlikeApply = false
			this.$store.dispatch('reserveusers_count', data).then(res => {
				if (custlikeApply) this.count2 = res.data.reserveusersConnection.aggregate.count
				else this.count3 = res.data.reserveusersConnection.aggregate.count
			})
		},
		maskingName(strName) {
			strName = strName.replace(/\s+/g, '')
			if (strName.length > 2) {
				var originName = strName.split('')
				originName.forEach((name, i) => {
					if (i === 0 || i === originName.length - 1) return
					originName[i] = '*'
				})
				return originName.join('')
			} else {
				var pattern = /.$/ // 정규식
				return strName.replace(pattern, '*')
			}
		},
		updateReserveuser() {
			if (this.dialogItem.id) {
				const data = {
					id: this.dialogItem.id,
					custlikeApply: true,
					custlike: this.custlike,
				}
				this.$store.dispatch('updateReserveuser', data).then(() => {
					this.sweetInfo.open = true
					this.detailCustomerDialog = false
					this.reserveusers()
					this.new_reserveusers()
				})
			} else alert('오류가 발생하였습니다. 다시시도해 주세요.')
		},
		realRangeTimeCount() {
			this.reserveusers()
		},
		allowed_datesEnd2(val) {
			let start = this.$moment(this.startPicker.date).format('YYMMDD')

			let startDate = new Date(this.startPicker.date)
			let end = new Date(startDate.setDate(startDate.getDate() + 240))
			let endDate = this.$moment(end).format('YYMMDD')

			val = this.$moment(val).format('YYMMDD') < endDate && this.$moment(val).format('YYMMDD') >= start
			return val
		},
		maskingPhoneNumber(phoneNumber) {
			const values = phoneNumber.split('-')
			if (values.length > 1) {
				values[1] = '*'.repeat(values[1].length - 2) + values[1][values[1].length - 2] + values[1][values[1].length - 1]
			}
			if (values.length > 2) {
				values[2] = '*'.repeat(values[2].length - 2) + values[2][values[1].length - 2] + values[2][values[1].length - 1]
			}
			return values.join('-')
		},
		new_reserveusers() {
			const data = {
				code: this.$route.params.code,
				reserveGroupCode: this.$route.params.qrcode,
				custlikeApply: false,
				start: 0,
				limit: 4,
			}
			this.$store.dispatch('pageReserveusers', data).then(res => {
				let array = res.data.reserveusers
				for (let index = 0; index < array.length; index++) {
					const el = array[index]
					el.name = this.maskingName(el.name)
					el.phone = this.maskingPhoneNumber(el.phone.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`))
				}
				this.newCustomer = array
			})
		},
		reserveusers() {
			const data = {
				code: this.$route.params.code,
				reserveGroupCode: this.$route.params.qrcode,
				created_at_gte: this.startPicker.date + 'T00:00:00.000Z',
				created_at_lte:
					this.$moment(this.endPicker.date)
						.add(1, 'd')
						.format('YYYY-MM-DD') + 'T00:00:00.000Z',
				start: (this.page - 1) * this.ItemPerpage,
				limit: this.ItemPerpage,
			}

			if (this.nameAndPhone !== '') {
				if (this.searchsel3.value === '이름') data.name = this.nameAndPhone
				else data.phone = this.nameAndPhone
			}
			if (this.searchsel.value !== '전체' && this.searchsel.value !== '-') data.custlike = this.searchsel.value
			if (this.searchsel.value === '-') data.custlikeApply = false
			this.$store.state.loading = true
			this.$store.dispatch('pageReserveusers', data).then(res => {
				this.datatable.items = []
				this.reserveCount = res.data.reserveusersConnection.aggregate.count
				this.pageCount = Math.ceil(res.data.reserveusersConnection.aggregate.count / this.ItemPerpage)
				let array = res.data.reserveusers
				for (let index = 0; index < array.length; index++) {
					const el = array[index]
					el.name = this.maskingName(el.name)
					el.phone = this.maskingPhoneNumber(el.phone.replace(/^(\d{2,3})(\d{3,4})(\d{4})$/, `$1-$2-$3`))
				}
				this.datatable.items = array
				this.pageKey += 1
				this.$store.state.loading = false
			})
		},
		detailCustomer(list) {
			this.detailCustomerDialog = !this.detailCustomerDialog
			this.dialogItem = list
			if (list.custlike) this.custlike = list.custlike
			else this.custlike = 'C'
		},
		refresh() {
			this.refreshCount = 5
			const countTime = setInterval(() => {
				this.refreshCount -= 1
				if (this.refreshCount === 0) clearInterval(countTime)
			}, 1000)
			this.new_reserveusers()
		},
		logout() {
			localStorage.removeItem('reserver')
			this.$router
				.push({ name: 'reserve_login', params: { code: this.$route.params.code, qrcode: this.$route.params.qrcode } })
				.catch(() => {})
		},
	},
}
</script>
<style lang="scss">
.reserve_page_info_dialog {
	font-size: 11px;
	text-align: center;
	.info-title {
		padding-top: 2px;
		min-width: 75px;
		width: 200px;
		height: 24px;
		background-color: #f5f5f5;
		border: 1px solid #c8c8c8;
		white-space: nowrap;
	}
	.info-value {
		white-space: nowrap;
		padding-top: 2px;
		width: 100%;
		height: 24px;
		border: 1px solid #c8c8c8;
	}
}
.detail-customer-dialog {
	margin: 24px 8px !important;
	background-color: white;
}
.reserve_page_datatable {
	.v-data-table__wrapper {
		margin-top: 4px !important;
	}
	.v-data-table > .v-data-table__wrapper > table > tbody > tr > td {
		padding: 0 4px !important;
		font-size: 11px !important;
	}
	.v-data-table > .v-data-table__wrapper > table thead tr th {
		padding: 0 4px !important;
		font-size: 12px !important;
	}
}
.reserve_page_newCustomer_List {
	justify-content: space-around;
	width: 320px;
	.info1 {
		font-size: 14px;
		margin-right: 4px;
	}
	.info2 {
		padding: 0 6px;
		border-radius: 8px;
		border: 1px solid #998fa2;
		font-size: 14px;
		margin-right: 4px;
	}
}
.reserve_page_title {
	font-size: 16px;
	font-weight: 700;
}
.reserve_page_newCustomer {
	margin: 12px;
	border: 1px solid #998fa2;
	border-radius: 22px;
	padding: 12px;
	.main_layout {
		overflow: auto;
		max-height: 120px;
	}
}
.bottom-btn {
	width: 50%;
	border-radius: 0px !important;
}
.reserve_page_mainText {
	font-size: 18px;
	.sub {
		font-size: 12px;
	}
}
.reserve_page_header {
	padding: 12px;
	background-color: #006986;
}
.reserve_page_info {
	height: 23px;
	background-color: white;
	padding: 1px 6px;
	border-radius: 4px;
	font-size: 12px;
}
.result-search {
	font-size: 12px;
	.count {
		font-weight: 700;
		color: #633efd;
	}
}
</style>
